import { useMemo } from 'react';
import { useSearchParams } from '../useSearchParams';
import { DateTime } from 'luxon';
import { dateParam } from '../../config/queryParams';
export var useDateQueryParams = function () {
    var searchParams = useSearchParams()[0];
    var paramDate = searchParams.get(dateParam);
    var paramDateTime = paramDate ? DateTime.fromISO(paramDate) : null;
    var selectedDate = useMemo(function () {
        return paramDateTime && paramDateTime.isValid
            ? DateTime.now().set({
                year: paramDateTime.year,
                month: paramDateTime.month,
                day: paramDateTime.day
            })
            : DateTime.now();
    }, [paramDate]);
    var selectedDateMonthStartWithBufferIso = selectedDate
        .startOf('month')
        .minus({ days: 6 })
        .toUTC()
        .startOf('day')
        .toISO();
    var selectedDateMonthEndWithBufferIso = selectedDate
        .endOf('month')
        .plus({ days: 6 })
        .toUTC()
        .endOf('day')
        .toISO();
    return {
        selectedDate: selectedDate,
        selectedDateMonthStartWithBufferIso: selectedDateMonthStartWithBufferIso,
        selectedDateMonthEndWithBufferIso: selectedDateMonthEndWithBufferIso
    };
};
export function updateDateQueryParam(date) {
    if ('URLSearchParams' in window) {
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set(dateParam, date.toISODate());
        var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.replaceState(null, '', newRelativePathQuery);
    }
}
